export default __webpack_public_path__ + "static/media/white-king.972c543e.png";